export const Designation = [
    { name: 'DELEGATE', code: 'DELEGATE' },
    { name: 'CO-ORDINATOR', code: 'CO-ORDINATOR' },
    { name: 'INTERNATIONAL FACULTY', code: 'INTERNATIONAL FACULTY' },
    { name: 'NATIONAL FACULTY', code: 'NATIONAL FACULTY' },
]